import { CustomRouter } from 'hooks/useCustomRouter.hook';

import { getSlidesLink } from 'utils/link';

export const handleStartVisit = (router: CustomRouter) => () => {
  const { id } = router.query;

  if (id) router.push(getSlidesLink(id));
};
